export interface SplashAdPayload {
  show: boolean
  /** When true (with success), native sticky banner may show after client rules (Extra, circulaire, etc.). */
  show_sticky_banner?: boolean
  slug?: string
  file: string
  format: 'image' | string
  duration?: number
  link?: string
  filling_color?: string
}

export interface SplashCheckResponse {
  success: number
  data?: SplashAdPayload
  /** Fallback if backend sends the flag at root instead of inside `data`. */
  show_sticky_banner?: boolean
}

/** Result for scheduling native sticky after `/splash/check`. */
export interface SplashStickyPolicy {
  allow: boolean
  /** Milliseconds to wait before setting allow to true; 0 means immediate. */
  delayMs: number
}

export function isValidSplashAdPayload(payload: any): payload is SplashAdPayload {
  if (!payload || typeof payload !== 'object')
    return false
  if (payload.show !== true)
    return false
  if (payload.format !== 'image')
    return false
  if (typeof payload.file !== 'string' || payload.file.trim().length === 0)
    return false
  return true
}

/**
 * Read sticky policy from splash/check without requiring a valid fullscreen image payload.
 */
export function parseSplashStickyPolicy(response: unknown): SplashStickyPolicy {
  const r = response as Partial<SplashCheckResponse> & { data?: any }
  if (!r || Number(r.success) !== 1)
    return { allow: false, delayMs: 0 }

  const data = r.data
  const showStickyBanner = data?.show_sticky_banner === true || r.show_sticky_banner === true
  if (!showStickyBanner)
    return { allow: false, delayMs: 0 }

  const showFullscreen = data?.show === true
  if (!showFullscreen)
    return { allow: true, delayMs: 0 }

  const duration = Number(data?.duration)
  const durSec = Number.isFinite(duration) && duration > 0 ? duration : 5
  return { allow: true, delayMs: Math.round((durSec + 1) * 1000) }
}
